import { type PublicBidDto } from "../../../../autogen/bff-api";

// Editability is decided by the BFF (isContentEditable). It is true for a fresh draft and for a
// draft withdrawn for editing, and false once the offer is delivered, signing, awarded or rejected.
export const isPublicBidEditable = (
  bid: Pick<PublicBidDto, "isContentEditable">,
): boolean => bid.isContentEditable === true;
